"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStreamAlert = createStreamAlert;
var _StreamAlertTypes = require("../../constants/StreamAlertTypes");
/**
 * @description Each instance of a StreamAlert is going to be used to display
 * alerts during a streaming session, ref: https://jira.cvent.com/browse/WEBINAR-7180
 * @param {string} color
 * @param {string} message
 * @param {string} persistenceType
 * @param {boolean} isDismissible
 * @param {number} delayInSeconds
 * @param {number} TTLInSeconds
 */
function createStreamAlert(color, message, persistenceType) {
  var isDismissible = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var delayInSeconds = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var TTLInSeconds = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 7;
  return {
    color: color,
    message: message,
    delayInSeconds: delayInSeconds,
    options: {
      type: color,
      indefinite: persistenceType === _StreamAlertTypes.STREAM_ALERT_PERSISTENT,
      timeout: TTLInSeconds * 1000,
      isDismissible: isDismissible
    }
  };
}